import { useTheme } from "@mui/material/styles";

import { Typography, Grid } from "@mui/material";
import Logo from "./Logo";
const LogoText = () => {
	const theme = useTheme();
	return (
		<Grid container>
			<Grid
				item
				sm={12}
				display="flex"
				alignItems="center"
				justifyContent="center"
				gap={1}
				sx={{ width: "100%" }}
			>
				<Logo width="6rem" />
				<Grid
					container
					display="block"
					sx={{ width: "fit-content" }}
					gap={0}
				>
					<Grid item sx={{ marginTop: "18px" }}>
						<Typography
							variant="logo_text"
							sx={{
								textDecoration: "none",
								color: theme.palette.secondary.main,
								fontSize: "1rem",
								fontFamily: "Roboto",
							}}
						>
							TLRG
						</Typography>
					</Grid>
					<Grid item sx={{ marginTop: "-10px" }}>
						<Typography
							variant="logo_text"
							sx={{
								textDecoration: "none",
								color: theme.palette.secondary.main,
								fontSize: "2rem",
								fontFamily: "Roboto",
							}}
						>
							LLN
						</Typography>
					</Grid>
					<Grid item sx={{ marginTop: "-25px" }}>
						<Typography
							variant="logo_text"
							sx={{
								textDecoration: "none",
								color: theme.palette.secondary.main,
								fontSize: "3rem",
								fontFamily: "Roboto",
							}}
						>
							ROBOT
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default LogoText;
